import React, { useState } from "react";
import { supabase } from "../supabaseClient";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const handleEmailAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);
    try {
      if (isSignUp) {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setMessage("Account created! You can now sign in.");
      } else {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-box">
        <h1 className="login-title">TELIOUS</h1>
        <p className="login-subtitle">GAMIFIED PRODUCTIVITY</p>
        <h2 className="login-heading">{isSignUp ? "CREATE ACCOUNT" : "SIGN IN"}</h2>
        {error && <p className="login-error">{error}</p>}
        {message && <p className="login-message">{message}</p>}
        <form onSubmit={handleEmailAuth} className="login-form">
          <input
            type="email"
            placeholder="EMAIL"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="login-input"
            required
          />
          <input
            type="password"
            placeholder="PASSWORD"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="login-input"
            required
          />
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "LOADING..." : isSignUp ? "SIGN UP" : "SIGN IN"}
          </button>
        </form>
        <p className="login-toggle">
          {isSignUp ? "Already have an account?" : "Don't have an account?"}
          <button onClick={() => setIsSignUp(!isSignUp)} className="login-toggle-btn">
            {isSignUp ? " SIGN IN" : " SIGN UP"}
          </button>
        </p>
      </div>
    </div>
  );
}
